<template>
  <div>
    <!--  class="page-break" -->
    <el-row style="height: 5cm; font-size: 12px;">
      <el-col v-if="Data != {}">
        <ul>
          <li style="margin-top: 1mm;">{{ Data.TC_NAME }}</li>
          <li style="font-weight: 600; margin-top: 5px; display: block;">{{ Data.DK_NAME }}
          </li>
          <li>
            产品信息：
            {{ Data.BRAND != '' ? Data.BRAND + 'nbsp;' : '' }}
            {{ Data.PRODUCT_NAME }}
            {{ Data.SPECIFICATION ? Data.SPECIFICATION + 'nbsp;' : '' }}
          </li>
          <li>订购数量：{{ Data.CUSTOMER_PRODUCT_COUNT + Data.TYPE_UNIT }} </li>
          <li>送货数量：{{ Data.CUSTOMER_NEED_COUNT + Data.TYPE_UNIT }} </li>
          <li>送货日期：{{ Data.CUSTOMER_SEND_DAY }}</li>
          <li>产品备注：{{ Data.PRODUCT_COMMENT }}</li>
          <br>
          <li v-if="Data.COUNT_OF_PRINT && Data.COUNT_OF_PRINT != 0"> 第{{ Data.COUNT_OF_PRINT + 1 }}次打印 </li>
        </ul>
      </el-col>
    </el-row>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    Data: {
      type: Object,
      default() {
        return {};
      },
      required: true,
    },
  },
  data() {
    return {
    };
  },
  created() {
  },
};
</script>
<style scoped>
ul {
  margin-top: 0;
  padding-top: 0;
  padding-left: 0;
}

li {
  list-style: none;
  font-size: 20px;
  line-height: 20px;
  color: #000;
  font-family: 黑体;
  margin: 10px 0 10px 10px;
  display: block;
}

span {
  font-size: 20px;
  line-height: 20px;
  color: #000;
  font-family: 黑体;
}

table {
  border-collapse: collapse;
  width: 130%;
  border: 1px solid #000;
  font-weight: bold;
}

td,
th {
  border: 1px solid #000;
  text-align: center;
  font-weight: normal;
  font-size: 20px;
  height: 20px;
  font-family: 黑体;
  color: #000;
  /* white-space:nowrap;overflow:hidden;text-overflow:ellipsis; */
  white-space: nowrap;
  /* 因为设置了block，所以需要设置nowrap来确保不换行
      overflow: hidden; /* 超出隐藏结合width使用截取采用效果*/
  text-overflow: ellipsis;
  /* 本功能的主要功臣，超出部分的剪裁方式 */
  -o-text-overflow: ellipsis;
  /* 特定浏览器前缀 */
  text-decoration: none;
}
/* @media print {
  .page-break {
    page-break-after: always;
  }
} */
</style>



// WEBPACK FOOTER //
// src/components/orderPrint/sortingDetailsPrintTax.vue